import React from 'react';

const LoadingSpinner = ({
  size = 'medium',
  color = 'brand',
  className = '',
  text = '',
}) => {
  const sizes = {
    small: 'h-4 w-4',
    medium: 'h-7 w-7',
    large: 'h-10 w-10',
  };

  const colors = {
    brand: 'text-brand-600',
    blue: 'text-brand-600',
    gray: 'text-ink-500',
    white: 'text-white',
  };

  const spinnerClasses = [
    'animate-spin',
    sizes[size] || sizes.medium,
    colors[color] || colors.brand,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <svg className={spinnerClasses} fill="none" viewBox="0 0 24 24">
        <circle
          className="opacity-20"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
        />
        <path
          className="opacity-90"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {text && <p className="text-sm text-ink-500">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
